import { useEffect, useRef, useState } from "react";
import AnimatedElement from "../AnimatedElement";
import imgmap from "../../assets/images/Contactenos/imgmap.png";
import map1 from "../../assets/images/Contactenos/map1.png";
import map2 from "../../assets/images/Contactenos/map2.png";
import map3 from "../../assets/images/Contactenos/map3.png";
import videoDron from "../../assets/images/Contactenos/video_dron.mp4";
import { useTranslation } from "react-i18next";
import "../../i18next";
import ContactForm from "./ContactForm";
import { Link } from "react-router-dom";
import linkedin from "../../assets/images/linkedin8.svg";

function SeccionContactenos() {
  const { t } = useTranslation();

  const videoRef = useRef(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOSDevice =
      /iPad|iPhone|iPod/.test(ua) &&
      /Safari/.test(ua) &&
      !/CriOS/.test(ua) &&
      !/FxiOS/.test(ua);

    setIsIOS(isIOSDevice);
  }, []);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  return (
    <>
      <header className="text-center md:text-left mt-10 md:mt-0">
        <AnimatedElement fromDirection="left">
          <h1 className="text-orangeAtm font-bold text-4xl md:text-8xl md:ml-8">
            {t("contacto.title")}
          </h1>
        </AnimatedElement>
      </header>

      <main className="w-11/12 mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
        <section className="space-y-6">
          <AnimatedElement fromDirection="left">
            <h2 className="text-customDarkBlue text-lg md:text-3xl text-center md:text-left">
              {t("contacto.text1")}
            </h2>
          </AnimatedElement>
          <AnimatedElement fromDirection="left">
            <div>
              <h3 className="text-customDarkBlue font-roboto text-2xl md:text-3xl font-bold">
                {t("contacto.email")}
              </h3>
              <p className="text-customDarkBlue text-sm md:text-base  whitespace-pre-line">
                {t("contacto.textEmail")}
              </p>
            </div>
          </AnimatedElement>
          <AnimatedElement fromDirection="left">
            <div>
              <h3 className="text-customDarkBlue font-roboto text-2xl md:text-3xl font-bold">
                {t("contacto.phone")}
              </h3>
              <p className="text-customDarkBlue text-sm md:text-base whitespace-pre-line">
                {t("contacto.textPhone")}
              </p>
            </div>
          </AnimatedElement>
          <Link to="#" className="mr-4">
            <img src={linkedin} className="h-8 mt-4" alt="Linkedin" />
          </Link>
          <ContactForm />
        </section>
        <section className="flex justify-center items-center">
          <AnimatedElement fromDirection="right">
            <img
              src={imgmap}
              alt="Global map"
              className="w-full max-w-md mx-auto"
            />
          </AnimatedElement>
        </section>
        <section className="flex justify-center items-center relative">
          <video
            ref={videoRef}
            loop
            muted
            playsInline
            autoPlay={!isIOS}
            className="w-full h-full object-cover"
          >
            <source src={videoDron} type="video/mp4" />
          </video>

          {isIOS && !isPlaying && (
            <button
              onClick={() => {
                handlePlay();
                setIsPlaying(true);
              }}
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/ text-black text-3xl px-6 py-3 rounded-full z-10"
            >
              ▶
            </button>
          )}
        </section>
      </main>

      <section className="mt-16">
        <AnimatedElement fromDirection="left">
          <div className="px-4 md:px-16">
            <h2 className="text-orangeAtm font-bold text-4xl md:text-6xl mb-4">
              {t("contacto.subtitle2")}
            </h2>
            <p className="text-customDarkBlue text-base md:text-xl">
              {t("contacto.text2")}
            </p>
          </div>
        </AnimatedElement>
      </section>

      <section className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 w-11/12 mx-auto">
        {[
          { img: map1, title: "titleImg1", text: "textImg1" },
          { img: map2, title: "titleImg2", text: "textImg2" },
          { img: map3, title: "titleImg3", text: "textImg3" },
        ].map((item, i) => (
          <AnimatedElement
            fromDirection={i === 0 ? "left" : i === 1 ? "top" : "bottom"}
            key={item.title}
          >
            <article className="text-center md:text-left">
              <img
                src={item.img}
                alt={t(`contacto.${item.title}`)}
                className="w-full mx-auto rounded-lg mb-4"
              />
              <h3 className="text-customDarkBlue text-xl md:text-3xl font-bold mb-2 font-roboto">
                {t(`contacto.${item.title}`)}
              </h3>
              <p className="text-customDarkBlue text-sm md:text-base font-semibold">
                {t(`contacto.${item.text}`)}
              </p>
            </article>
          </AnimatedElement>
        ))}
      </section>
    </>
  );
}

export default SeccionContactenos;
